// src/components/Modals/DeleteFavoriteModal.jsx
import React, { useRef, useEffect, useState } from 'react';

const DeleteFavoriteModal = ({
  isOpen,
  onClose,
  onBack,
  elevator,
  onConfirm
}) => {
  const textRef = useRef(null);
  const [isMultiLine, setIsMultiLine] = useState(false);

  useEffect(() => {
    if (isOpen && textRef.current) {
      const lineHeight = parseFloat(window.getComputedStyle(textRef.current).lineHeight);
      const height = textRef.current.clientHeight;
      setIsMultiLine(height > lineHeight * 1.5);
    }
  }, [isOpen]);

  const handleDeleteConfirm = async () => {
    if (elevator) {
      await onConfirm(elevator.regNumber);
      onClose();
    }
  };

  const handleModalClose = () => {
    onClose();
  };

  const handleModalBack = () => {
    onBack();
  }

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 z-[80] flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-xs mx-auto transform transition-all duration-300 ease-out">
        <div className="p-6 text-center relative">
          <button
            onClick={handleModalClose}
            className="absolute top-3 right-3 text-gray-400 hover:text-gray-600"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>

          <div className="w-12 h-12 mx-auto mb-4 flex justify-center items-center">
            <img src="./assets/static/MEL_4.png" className="h-6 w-6" alt="削除アイコン" />
          </div>

          <h3 className="text-lg font-bold text-gray-800">マイエレベータから削除</h3>
          <p
            ref={textRef}
            className={`text-sm text-gray-600 mt-2 ${isMultiLine ? 'text-left' : 'text-center'}`}
          >
            「<span className="font-semibold">{elevator?.name}</span>」を削除しますか？
          </p>

          <div className="mt-12 flex gap-4">
            <button
              onClick={handleModalBack}
              className="w-full bg-white border border-gray-200 text-gray-700 font-bold py-2 px-4 rounded-lg hover:bg-gray-50 transition-colors"
            >
              戻る
            </button>
            <button
              onClick={handleDeleteConfirm}
              className="w-full ux-bg-dark-gray text-white font-bold py-2 px-4 rounded-lg hover:bg-red-700 transition-colors"
            >
              削除
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteFavoriteModal;